import axios from 'axios';
import constants from '@/constants';

function getStoredToken() {
  try {
    return localStorage.getItem('x-access-token') || sessionStorage.getItem('x-access-token');
  } catch (error) {
    return sessionStorage.getItem('x-access-token');
  }
}

export default (portalVersion = 1) => {
  const token = getStoredToken();

  return axios.create({
    baseURL     : `${constants.PORTAL_API_ROOT}/${portalVersion}`,
    responseType: 'json',
    headers     : {
      'Content-Type'   : 'application/json',
      'Accept'         : 'application/json',
      'applicationKey' : '00000-30000-00000-00000-00030',
      'integrationType': constants.INTEGRATION_TYPE,
      ...(token ? { 'x-access-token': token } : {}),
    },
  });
};

export { getStoredToken };
